import { render, staticRenderFns } from "./MyContentResult.vue?vue&type=template&id=45988198&"
import script from "./MyContentResult.vue?vue&type=script&lang=js&"
export * from "./MyContentResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports